<template>
  <div>
    <md-dialog :md-active.sync="showDialog" id="dlg-manage-infomation">
      <md-toolbar md-elevation="0">
        <h3 class="md-title" style="flex: 1">{{Info.campaign_code}}</h3>
        <md-menu
          md-align-trigger
          v-if="!isApprover && isOwner && (permit.acl['campaign'].menus['manage'].edit == true || permit.acl['campaign'].menus['manage'].delete==true)"
        >
          <md-button class="md-icon-button" md-menu-trigger>
            <md-icon>more_vert</md-icon>
          </md-button>
          <md-menu-content style="z-index:20;">
            <!-- <md-menu-item>Send to approve</md-menu-item> -->
            <!-- <md-menu-item  disabled @click="data = 'click disabled'">Recall</md-menu-item> -->
            <md-menu-item
              @click="editCampaign(Info._id)"
              v-if="!isPending && permit.acl['campaign'].menus['manage'].edit == true && !Expired"
            >Edit</md-menu-item>
            <!-- <md-menu-item>Duplicate</md-menu-item> -->
            <md-menu-item
              @click="duplicateCampaign(Info._id)"
              v-if="!isPending && permit.acl['campaign'].menus['manage'].edit == true"
            >Duplicate</md-menu-item>
            <md-menu-item
              @click="sendApproveCampaign(Info._id)"
              v-if="!isReject && !isPending && permit.acl['campaign'].menus['manage'].edit == true && !Expired"
            >Send Approve</md-menu-item>
            <md-menu-item
              @click="recallCampaign(Info._id)"
              v-if="isPending && permit.acl['campaign'].menus['manage'].edit == true && !Expired"
            >Recall</md-menu-item>

            <md-menu-item
              @click="deleteCampaign(Info._id)"
              v-if="!isPending && permit.acl['campaign'].menus['manage'].delete == true"
            >Delete</md-menu-item>

            <!-- <md-menu-item
              @click="approveCampaign(Info._id)"
              v-if="permit.acl['campaign'].menus['manage'].approve == true && !Expired"
            >Approve</md-menu-item>
            <md-menu-item
              @click="rejectCampaign(Info._id)"
              v-if="permit.acl['campaign'].menus['manage'].approve == true && !Expired"
            >Reject</md-menu-item>-->
          </md-menu-content>
        </md-menu>
      </md-toolbar>
      <md-dialog-content>
        <md-card class="main-content" style="margin-top:24px;">
          <md-card-header>
            <md-card-header-text>
              <div class="mktops-subheader-text">Basic Info</div>
            </md-card-header-text>
            <md-button
              class="md-button md-primary"
              @click="editCampaign(Info._id,1)"
              v-if="!isPending && !isApprover && isOwner && permit.acl['campaign'].menus['manage'].add == true && !Expired"
            >EDIT</md-button>
          </md-card-header>
          <div class="md-layout" style="padding-left:20px;padding-right:20px;">
            <!-- <div class="md-layout-item md-size-5">
              <div class="mktops-square-blue">
                <md-icon>show_chart</md-icon>
              </div>
            </div> -->
            <div class="md-layout-item md-size-95" style="padding-left:10px;padding-bottom:10px;">
              <table class="mktops-info-table">
                <tr>
                  <th class="md-tab-blue-text table" width="150">Campaign Code</th>
                  <th class="md-tab-blue-text table" width="150">Campaign Title</th>
                  <th class="md-tab-blue-text table">Campaign Detail</th>
                </tr>
                <tr>
                  <td>{{Info.campaign_code}}</td>
                  <td>{{Info.campaign_title}}</td>
                  <td>{{Info.campaign_detail}}</td>
                </tr>
                <tr>
                  <td class="md-tab-blue-text table">Start Date</td>
                  <td class="md-tab-blue-text table">End Date</td>
                  <td class="md-tab-blue-text table">Join Within</td>
                </tr>
                <tr>
                  <td>{{convertDate(Info.startdate)}}</td>
                  <td>{{convertDate(Info.enddate)}}</td>
                  <td>{{Info.join_within}} days</td>
                </tr>
              </table>
            </div>
          </div>
        </md-card>
        <md-card class="main-content" style="margin-top:12px;">
          <md-card-header>
            <md-card-header-text>
              <div class="mktops-subheader-text">Selected Products</div>
            </md-card-header-text>
            <md-button
              class="md-button md-primary"
              @click="editCampaign(Info._id,2)"
              v-if="!isPending && !isApprover && isOwner && permit.acl['campaign'].menus['manage'].add == true && !Expired"
            >EDIT</md-button>
          </md-card-header>
          <div class="mktops-produce-table" v-if="Info.products">
            <md-table v-model="Info.products" md-fixed-header style="height: 200px;">
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Code" md-sort-by="code">{{ item.code }}</md-table-cell>
                <md-table-cell
                  class="md-table-cell-description"
                  md-label="Description"
                  md-sort-by="description"
                >{{ item.title_th }}</md-table-cell>
                <md-table-cell
                  md-label="Unit"
                  md-sort-by="unit"
                >{{ item.selling_um_title }}</md-table-cell>
                <md-table-cell md-label="Cost"  md-numeric>{{ item.cost.toString().toLocaleString() }}</md-table-cell>
                <!-- <md-table-cell md-label="Price(A2)" md-sort-by="price" md-numeric>
                  <label style="padding-right:5px">{{ item.price.toLocaleString() }}</label>
                </md-table-cell> -->
              </md-table-row>
            </md-table>
          </div>
        </md-card>
        <md-card class="main-content" style="margin-top:12px;">
          <md-card-header>
            <md-card-header-text>
              <div class="mktops-subheader-text">Condition Sets</div>
            </md-card-header-text>
            <md-button
              class="md-button md-primary"
              @click="editCampaign(Info._id,3)"
              v-if="!isPending && !isApprover && isOwner  && permit.acl['campaign'].menus['manage'].add == true && !Expired"
            >EDIT</md-button>
          </md-card-header>
          <md-tabs md-active-tab="tab-0">
            <md-tab
              v-for="(item , index) in Info.sets"
              :key="index"
              :id="`tab-${index}`"
              :md-label="item.name"
            >
              <div class="md-layout-item md-layout md-gutter">
                <div class="md-layout-item md-size-60" style="padding-left:0px">
                  <div class="md-layout-item md-layout md-gutter">
                    <div class="md-layout-item md-size-30" style="padding-left:0px">
                      <div class="md-tab-blue-text">Set</div>
                      <div class="md-tab-text" style="margin-top:3px">{{item.name}}</div>
                    </div>
                    <div class="md-layout-item md-size-70"></div>
                    <div class="md-layout-item md-size-100 rows-item">
                      <div class="mktops-text-condition">Conditions</div>
                    </div>

                    <div class="md-layout-item md-size-100 rows-item" v-if="item.point">
                      <div class="section-sub-line" style="width:300px;">
                        <label class="mktops-text-qty" style="margin-right:20px;">
                          <b>Point</b>
                        </label>
                        <label class="md-tab-text">{{item.point.end}}</label>
                      </div>
                    </div>

                    <div class="md-layout-item md-size-100 rows-item">
                      <div class="mktops-text-condition">Reward</div>
                    </div>

                    <div
                      class="free-items-box"
                      v-for="(data,index_rewards) in item.rewards"
                      :key="index_rewards"
                    >
                      <div class="md-layout">
                        <div class="md-layout-item">
                          <img class="imgItem" :src="data.image">
                        </div>
                        <div class="md-layout-item right">
                          <div class="title">Product Name</div>
                          <div class="data">{{data.name}}</div>
                          <div class="title">ESTIMATE COST</div>
                          <div class="data">{{data.qty}}</div>
                          <div class="title" v-if="data.sendDate">SEND DATE</div>
                          <div class="data" v-if="data.sendDate">{{data.sendDate}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="md-layout-item md-size-40 section-line">
                  <div class="mktops-text-condition">Customer Groups</div>
                  <div class="md-layout filter-chips">
                    <md-chip
                      style="display: inline-grid;margin-left: 0px;"
                      class="md-primary"
                      v-for="(customer,index_customer) in item.customers"
                      :key="`customer_${index_customer}`"
                    >({{index_customer+1}}) {{customer.group_name}}</md-chip>
                  </div>
                </div>
              </div>
            </md-tab>
          </md-tabs>
        </md-card>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button @click="onClose" style="margin-right:20px;">Close</md-button>
        <md-button
          class="btn-reject"
          @click="onReject"
          v-if="isApproveBy && isPending && permit.acl['campaign'].menus['manage'].approve"
        >Reject</md-button>
        <md-button
          class="btn-approve"
          @click="onApprove"
          v-if="isApproveBy && isPending && permit.acl['campaign'].menus['manage'].approve"
        >Approve</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="showConfirmRecall"
      md-title="Recall a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmRecall"
      @md-opened="setLayerDialog"
    />

    <md-dialog-confirm
      :md-active.sync="showConfirmSendApprove"
      md-title="Send to approve a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmSendApprove"
      @md-opened="setLayerDialog"
    />

    <md-dialog-confirm
      :md-active.sync="showConfirmApprove"
      md-title="Approve a Campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmApprove"
      @md-opened="setLayerDialog"
    />

    <md-dialog-confirm
      :md-active.sync="showConfirmReject"
      md-title="Reject a campaign."
      md-content="Are you sure?"
      md-confirm-text="Confirm"
      md-cancel-text="Cancel"
      @md-confirm="onConfirmReject"
      @md-opened="setLayerDialog"
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "dialog-infomation",
  props: ["dataCampaign", "showDialog"],
  computed: {
    Info() {
      return this.dataCampaign;
    },
    user() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isOwner() {
      if (this.user.username == this.Info.createby) return true;
      else return false;
    },
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    Expired() {
      if (this.Info.campaign_status == "Expired") return true;
      else return false;
    },
    isApprover() {
      if (this.permit.acl["campaign"].menus["manage"].approve == true)
        return true;
      else false;
    },
    isReject() {
      if (this.Info.campaign_status == "Reject") return true;
      else false;
    },
    isPending() {
      if (this.Info.campaign_status == "Pending") return true;
      else false;
    },
    unitmaster() {
      return this.$store.getters["cpcreate/unitmaster"];
    },
    isApproveBy(){
      if (this.user.code == this.Info.approve_by) return true;
      else return false;
    }
  },
  data() {
    return {
      showConfirmRecall: false,
      showConfirmSendApprove: false,
      showConfirmApprove: false,
      showConfirmReject: false
    };
  },
  created(){
    this.$store.dispatch('cpcreate/getUnitMaster')
  },
  methods: {
    convertDate(date) {
      return moment(new Date(date)).format("MMM D, YYYY");
    },
    onClose() {
      this.$emit("onClose", false);
    },
    editCampaign(id, step) {
      this.$emit("editCampaign", this.Info._id, step);
    },
    deleteCampaign(id) {
      this.showInfo = false;
      this.$emit("deleteCampaign", this.Info._id);
    },
    duplicateCampaign(id) {
      this.showInfo = false;
      this.$emit("duplicateCampaign", this.Info._id);
    },

    sendApproveCampaign(id) {
      this.showConfirmSendApprove = true;
    },

    recallCampaign(id) {
      this.showConfirmRecall = true;
    },

    onConfirmRecall() {
      this.showInfo = false;
      this.$emit("recallCampaign", this.Info._id);
    },

    onConfirmSendApprove() {
      this.showInfo = false;
      this.$emit("sendToApproveCampaign", this.Info._id);
    },
    setLayerDialog() {
      var x = document.getElementsByClassName("md-dialog")[1];
      x.style.zIndex = 13;
      var y = document.getElementsByClassName("md-overlay")[1];
      y.style.zIndex = 11;
    },
    onReject() {
      this.showConfirmReject = true;
    },
    onConfirmReject() {
      this.$emit("onReject", this.Info._id);
    },
    onApprove() {
      this.showConfirmApprove = true;
    },
    onConfirmApprove() {
      this.$emit("onApprove", this.Info._id);
    }
  }
};
</script>

<style lang="scss">
#dlg-manage-infomation {

  transform: unset !important;
  top : 10% !important;
  left: 10% !important;

  width: 80% !important;
  .md-toolbar {
    background: white;
    border: none;
  }
  .md-dialog-content {
    background: #eeeeee !important;
  }
  .btn-reject {
    color: red;
  }
  .btn-approve {
    color: green;
  }
  table{
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.mktops-square-blue {
    width: 30px;
    height: 30px;
    background-color: #3B62C1;
    border-radius: 4px;
    line-height: 30px;
    text-align: center;
    font-size: 10px;
    margin-top: 8px;
    .md-icon {
      color: white;
    }
  }
  .mktops-subheader-text{
    font-size:14px;
  }
  .md-tabs-navigation {
    padding-left: unset;
    border-bottom: 1px solid #d7d7d7;
  }
  .md-tab {
    padding: 20px;
  }
  .md-tab-text .md-tab-blue-text {
    font-size: 14px;
  }
  .md-tab-blue-text {
    color: #3B62C1;
    font-size: 12px;
    text-align:left;
  }
  .md-tab-blue-text.table {
    font-weight: 400;
  }
  .rows-item {
    padding-left: 0px;
    margin-top: 16px;
    margin-left:20px;
  }
  .mr-20 {
    margin-right: 20px;
  }
  .mktops-text-condition {
    font-family: Roboto;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }
  .mktops-text-qty {
    font-family: Roboto;
    font-size: 16px;
    color: #000000;
  }
  .md-card-header{
    padding:10px;
  }
  </style>